import React, { useState } from "react";
import "./BookingForm.css";

const BookingForm = () => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Validation
  const validateForm = (formData) => {
    let tempErrors = {};

    const name = (formData.get("name") || "").trim();
    const email = (formData.get("email") || "").trim();
    const phone = (formData.get("phone") || "").trim();
    const vehicle = (formData.get("vehicle") || "").trim();
    const date = (formData.get("date") || "").trim();

    if (!name) tempErrors.name = "Name is required";

    if (!email) {
      tempErrors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      tempErrors.email = "Invalid email address";
    }

    if (!phone) {
      tempErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(phone)) {
      tempErrors.phone = "Phone must be 10 digits";
    }

    if (!vehicle) tempErrors.vehicle = "Please select a vehicle";
    if (!date) tempErrors.date = "Booking date is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    // Mobile first tap opens form
    if (window.innerWidth <= 700 && !isOpen) {
      setIsOpen(true);
      return;
    }

    const formEle = e.target;
    const formData = new FormData(formEle);

    if (!validateForm(formData)) return;

    setLoading(true);

    fetch(
      "https://script.google.com/macros/s/AKfycbwS1lPHguT8jw4BUr8u8P71KX1jsV-MOfsn4HOk-kPLNyg274J4fHHMnTZItmlNgObR/exec",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then(() => {
        formEle.reset();
        setErrors({});
        setIsOpen(false);
        setShowSuccess(true);
      })
      .catch(() => {
        alert("Booking failed!");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="simple-booking-wrapper">
      {/* FULLSCREEN LOADER */}
      {loading && (
        <div className="fullscreen-loader">
          <div className="loader"></div>
          <p>Submitting your booking...</p>
        </div>
      )}

      {/* SUCCESS POPUP */}
      {showSuccess && (
        <div className="success-overlay">
          <div className="success-popup">
            <div className="success-icon">✅</div>
            <h3>Scooty Booked!</h3>
            <p>Scooty booked successfully 🚀</p>
            <button onClick={() => setShowSuccess(false)}>OK</button>
          </div>
        </div>
      )}

      <form
        className={`simple-booking-card ${isOpen ? "open" : ""}`}
        onSubmit={handleSubmit}
        noValidate
      >
        {/* Close (Mobile) */}
        <span
          className={`close-icon ${isOpen ? "show" : ""}`}
          onClick={() => setIsOpen(false)}
        >
          ✕
        </span>

        <div className="input-group">
          <input type="text" name="name" placeholder="Your Name" />
          {errors.name && <span className="error">{errors.name}</span>}
        </div>

        <div className="input-group">
          <input type="email" name="email" placeholder="Your Email" />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>

        <div className="input-group">
          <input type="tel" name="phone" placeholder="Phone Number" />
          {errors.phone && <span className="error">{errors.phone}</span>}
        </div>

        <div className="input-group">
          <select name="vehicle">
            <option value="">Select Vehicle</option>
            <option value="NOVA">NOVA</option>
            <option value="NOVA-S">NOVA-S</option>
            <option value="NOVA-X">NOVA-X</option>
            <option value="EDGE">EDGE</option>
            <option value="EDGE PLUS">EDGE PLUS</option>
            <option value="ELITE 5G">ELITE 5G</option>
            <option value="ELITE 5G-2.0">ELITE 5G-2.0</option>
            <option value="WARIVO NEO">WARIVO NEO</option>
            <option value="SHARK">SHARK</option>
            <option value="ALEXA">ALEXA</option>
            <option value="CRUZE">CRUZE</option>
            <option value="L1-PLUS">L1-PLUS</option>
            <option value="REVO BOAT">REVO BOAT</option>
          </select>
          {errors.vehicle && <span className="error">{errors.vehicle}</span>}
        </div>

        <div className="input-group">
          <input type="date" name="date" />
          {errors.date && <span className="error">{errors.date}</span>}
        </div>

        <div className="button-group">
          <button type="submit" disabled={loading}>
            Book Scooty
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookingForm;
